import {useEffect, useState} from "react";
import appConstants from "../../../../constants";
import {selectFilterValue, unselectFilterValue} from '../../helpers';

const defaults = Object.freeze({
  initialSelectedCountry: null,
  initialSelectedCountryCode: null,
  initialSelectedCountryName: null,
  incomingLinkCountryCode: null
});

export default function useCountryFilter(
  countryList,
  initialSelectedCountry = defaults.initialSelectedCountry,
  incomingLinkCountryCode = defaults.incomingLinkCountryCode
) {

  const [countryFilterValues, setCountryFilterValues] = useState([]);

  const [isCountryFilterDropdownOpened, setIsCountryFilterDropdownOpened] = useState(false);
  //const [previouslySelectedCountry, setPreviouslySelectedCountry] = useState(null);
  const [previouslySelectedCountryCode, setPreviouslySelectedCountryCode] = useState(null);

  const [selectedCountry, setSelectedCountry] = useState(initialSelectedCountry);
  const [selectedCountryCode, setSelectedCountryCode] = useState(!!initialSelectedCountry ? initialSelectedCountry[appConstants.KEY_CODE] : defaults.initialSelectedCountryCode);
  const [selectedCountryName, setSelectedCountryName] = useState(!!initialSelectedCountry ? initialSelectedCountry[appConstants.KEY_NAME] : defaults.initialSelectedCountryName);

  const [isIncomingLinkParamLocationSuccessfullySelected, setIsIncomingLinkParamLocationSuccessfullySelected] = useState(false);

  function selectCountryFilterValue(countryFilterValue) {
    const updateCountryFilterOperationResults =
      selectFilterValue(countryFilterValue, countryFilterValues);
    if (updateCountryFilterOperationResults.areFilterValuesUpdated) {
      setCountryFilterValues(previousValue => [...updateCountryFilterOperationResults.updatedFilterValues]);
      let selectedCountryFilterValue = { ...countryFilterValue };
      selectedCountryFilterValue[appConstants.KEY_IS_SELECTED] = true;
      //setPreviouslySelectedCountry(previousValue => selectedCountry);
      setPreviouslySelectedCountryCode(previousValue => !!selectedCountry ? selectedCountry[appConstants.KEY_CODE]: null);
      setSelectedCountry(previousValue => selectedCountryFilterValue );
      setSelectedCountryCode( previousValue => countryFilterValue[appConstants.KEY_CODE]);
      setSelectedCountryName( previousValue => countryFilterValue[appConstants.KEY_NAME]);
      setIsCountryFilterDropdownOpened(previousValue => false);
    }
  }

  function unselectCountryFilterValue(countryFilterValue) {
    const updateCountryFilterOperationResults =
      unselectFilterValue(countryFilterValue, countryFilterValues);
    if (updateCountryFilterOperationResults.areFilterValuesUpdated) {
      setCountryFilterValues(previousValue => [...updateCountryFilterOperationResults.updatedFilterValues]);
      //setPreviouslySelectedCountry(previousValue => null);
      setPreviouslySelectedCountryCode(previousValue => null);
      setSelectedCountry(previousValue => null );
      setSelectedCountryCode( previousValue => null);
      setSelectedCountryName( previousValue => null);
      setIsCountryFilterDropdownOpened(previousValue => false);
    }
  }

  function resetCountryFilterValues() {
    //setPreviouslySelectedCountry(previousValue => null);
    setPreviouslySelectedCountryCode(previousValue => null);
    setSelectedCountry(previousValue => null );
    setSelectedCountryCode( previousValue => null);
    setSelectedCountryName( previousValue => null);
    setCountryFilterValues(previousValue => [...countryList]);
  }

  function toggleCountryFilterDropdown() {
    setIsCountryFilterDropdownOpened(previousValue => !isCountryFilterDropdownOpened);
  }

  function syncPreviousAndCurrentlySelectedCountry() {
    //setPreviouslySelectedCountry(previousValue => selectedCountry);
    setPreviouslySelectedCountryCode(previousValue => selectedCountryCode);
  }

  useEffect(
    () => {
      if(!!countryList && !!countryList.length) {
        if(!!incomingLinkCountryCode) {
          const toBeSelectedCountryCode = incomingLinkCountryCode.toUpperCase();
          let toBeSelectedCountry = countryList.filter((country) => country[appConstants.KEY_CODE] === toBeSelectedCountryCode);
          if(!!toBeSelectedCountry.length) {
            toBeSelectedCountry = { ...toBeSelectedCountry[0] };
            toBeSelectedCountry[appConstants.KEY_IS_SELECTED] = true;
            setPreviouslySelectedCountryCode(!!selectedCountry ? selectedCountry[appConstants.KEY_CODE]:null);
            setSelectedCountry(toBeSelectedCountry);
            setCountryFilterValues(previousValue => {
              const updatedCountryList = countryList.map((country) => country[appConstants.KEY_CODE] === toBeSelectedCountry[appConstants.KEY_CODE] ? toBeSelectedCountry : country);
              return [...updatedCountryList];
            });
            setSelectedCountryCode(toBeSelectedCountry[appConstants.KEY_CODE]);
            setSelectedCountryName(toBeSelectedCountry[appConstants.KEY_NAME]);
            setIsIncomingLinkParamLocationSuccessfullySelected(true);
          }
        }
        else {
          if(!!initialSelectedCountry) {
            setCountryFilterValues(previousValue => {
                const updatedCountryList = countryList.map((country) => country[appConstants.KEY_CODE] === initialSelectedCountry[appConstants.KEY_CODE] ? initialSelectedCountry : country);
                return [...updatedCountryList];
            });
          }
          else {
            setCountryFilterValues(previousValue => [...countryList]);
          }
        }
      }
    },
    [countryList, initialSelectedCountry, incomingLinkCountryCode]
  );

  return {
    isCountryFilterDropdownOpened,
    countryFilterValues,
    //previouslySelectedCountry,
    previouslySelectedCountryCode,
    selectedCountry,
    selectedCountryCode,
    selectedCountryName,
    selectCountryFilterValue,
    unselectCountryFilterValue,
    resetCountryFilterValues,
    syncPreviousAndCurrentlySelectedCountry,
    toggleCountryFilterDropdown,
    isIncomingLinkParamLocationSuccessfullySelected
  }
}
